/** Phone "Meer" sheet: the pages that do not fit in the tab bar, plus logout. */
import clsx from 'clsx';
import { ChevronRight, LogOut } from 'lucide-react';
import { NavLink } from 'react-router';
import { Avatar } from '../components/Avatar.js';
import { Sheet } from '../components/Dialog.js';
import { logout, useMe } from '../lib/session.js';
import styles from './AppShell.module.css';
import { TAB_PATHS, type NavItem } from './nav.js';
import { roleLabel } from './UserMenu.js';

export function MoreSheet({ open, onClose, items }: { open: boolean; onClose: () => void; items: readonly NavItem[] }) {
  const me = useMe();
  const rest = items.filter((i) => !TAB_PATHS.includes(i.to));
  return (
    <Sheet open={open} onClose={onClose} title="Meer">
      {me && (
        <div className={styles.moreUser}>
          <Avatar name={me.user.name} size={40} />
          <div className="grow">
            <div className="truncate">
              <strong>{me.user.name}</strong>
            </div>
            <div className="small muted truncate">
              {me.user.email} · {roleLabel(me.user.roles)}
            </div>
          </div>
        </div>
      )}
      <ul className={styles.moreList}>
        {rest.map((item) => (
          <li key={item.to}>
            <NavLink to={item.to} className={({ isActive }) => clsx(styles.moreLink, isActive && styles.moreLinkActive)} onClick={onClose}>
              <item.icon aria-hidden="true" />
              <span className="grow">{item.label}</span>
              <ChevronRight aria-hidden="true" className={styles.moreChevron} />
            </NavLink>
          </li>
        ))}
        <li>
          <button type="button" className={clsx(styles.moreLink, styles.moreDanger)} onClick={() => void logout()}>
            <LogOut aria-hidden="true" />
            <span className="grow">Uitloggen</span>
          </button>
        </li>
      </ul>
    </Sheet>
  );
}
